<button mat-icon-button color="primary" aria-hidden="true">
    <mat-icon svgIcon="csv_download" aria-hidden="true" class="material-icons big-icon" ></mat-icon>
</button>